import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=01263218&scoped=true"
import script from "./NewRegister.vue?vue&type=script&lang=js"
export * from "./NewRegister.vue?vue&type=script&lang=js"
import style1 from "./NewRegister.vue?vue&type=style&index=1&id=01263218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01263218",
  null
  
)

export default component.exports